import { useAssetContext } from '@airship-platform/airship-patterns';
import { CubeIcon } from '@airship-platform/jam-web/icons';
import Box from '@mui/material/Box';
import { useState } from 'react';

type SystemTypeImageProps = {
  systemTypeId: string;
  width?: string;
  height?: string;
};

const SystemTypeImage: React.FC<SystemTypeImageProps> = ({
  systemTypeId,
  width = '8rem',
  height = '6.25rem',
}) => {
  const { getAssetUrl } = useAssetContext();
  const [showFallback, setShowFallback] = useState(false);

  const assetUrl = getAssetUrl(['system-type-assets', systemTypeId, 'asset']);

  return !showFallback ? (
    <Box
      component={'img'}
      src={assetUrl}
      onError={() => setShowFallback(true)}
      sx={{
        width: width,
        height: height,
        objectFit: 'contain',
      }}
    />
  ) : (
    <CubeIcon width={width} />
  );
};

export default SystemTypeImage;
